"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProduct = void 0;
var _react = require("react");
var _context = require("../../context");
const useProduct = () => {
  const context = (0, _react.useContext)(_context.productContext);
  if (context) {
    return context;
  }
  throw new Error('Value for `productContext` must be set.');
};
exports.useProduct = useProduct;
